module.exports = __webpack_public_path__ + "img/piano-2.f412bb3a.png";